// AddressBookForm.js
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Col, Input, Label, FormFeedback, Row } from 'reactstrap';
import Action from '../../../redux/Action';
import ManageServices from '../../../utility/api/services/ManageServices';
import { myToast } from '../../../snippets/snippets';
import { useDispatch } from 'react-redux';
import { getUserAddressData } from '../../../utility/api/services/UserPortal/UserSlice';

// Validation schema using Yup
const SignupSchema = yup.object().shape({
  firstName: yup.string()
    .min(3, 'First Name must be at least 3 characters')
    .max(30, 'First Name must be at most 30 characters')
    .required('First Name is required'),
  lastName: yup.string()
    .min(3, 'Last Name must be at least 3 characters')
    .max(30, 'Last Name must be at most 30 characters')
    .required('Last Name is required'),
  phone: yup.string()
    .matches(/^\d{10}$/, 'Phone number must be 10 digits')
    .required('Phone Number is required'),
  street: yup.string().required('Street is required'),
  apartment: yup.string(),
  city: yup.string().required('City is required'),
  province: yup.string().required('Province/State is required'),
  country: yup.string().required('Country is required'),
  zipCode: yup.string().required('Zip Code is required'),
});

const AddressBookForm = ({ showState, formData, onCancel }) => {

  const dispatch = useDispatch()

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(SignupSchema),
    defaultValues: {
      firstName: formData?.firstName || '',
      lastName: formData?.lastName || '',
      phone: formData?.phone || '',
      street: formData?.street || '',
      apartment: formData?.apartment || '',
      city: formData?.city || '',
      province: formData?.province || '',
      country: formData?.country || '',
      zipCode: formData?.zipCode || '',
      isDefaultDelivery: formData?.defaultDeliveryAddress || false,
      isDefaultBilling: formData?.defaultBillingAddress || false,
    },
  });

  const dataAvaliable = formData && Object.values(formData).some(value => value !== '');


  const [firstName, setFirstName] = useState(dataAvaliable ? formData.firstName : '');
  const [lastName, setLastName] = useState(dataAvaliable ? formData.lastName : '');
  const [phone, setPhone] = useState(dataAvaliable ? formData.phone : '');
  const [street, setStreet] = useState(dataAvaliable ? formData.street : '');
  const [apartment, setApartment] = useState(dataAvaliable ? formData.apartment : '');
  const [city, setCity] = useState(dataAvaliable ? formData.city : '');
  const [province, setProvince] = useState(dataAvaliable ? formData.province : '');
  const [country, setCountry] = useState(dataAvaliable ? formData.country : '');
  const [zipCode, setZipCode] = useState(dataAvaliable ? formData.zipCode : '');
  const [isDefaultDelivery, setIsDefaultDelivery] = useState(dataAvaliable ? formData.defaultDeliveryAddress : false);
  const [isDefaultBilling, setIsDefaultBilling] = useState(dataAvaliable ? formData.defaultBillingAddress : false);


  const handleTimeoutAlert = (obj) => {
    
    console.log('obj', obj);
    const myPromise = new Promise(async(resolve, reject) => {

        if(dataAvaliable){
          console.log('CALLED')
          ManageServices.editAddress(obj, formData._id)
          .then((response) => {
              const result = response.data
              console.log('RESULT', result)
              
              // props.setInputModal(false)

              if(result.statusCode == 200){
                dispatch(Action.userHandler())
                onCancel()

              }

              resolve(result)
          }).catch((err) => {
          reject(err)
      })
        }else{
           ManageServices.addAddress(obj)
            .then((response) => {
                const result = response.data
                console.log('RESULT', response)

                
                if(result.statusCode == 200){
                  // dispatch(Action.userHandler())
                  dispatch(getUserAddressData())
                  onCancel()

                }


                resolve(result)
            }).catch((err) => {
            reject(err)
        })
        }
       
         
    })
    console.log('myToastUpdate', myPromise)
    return myToast(myPromise)
  }

  const onSubmit = (data) => {
   
    // dispatch(addUserAddress(formData)); // Dispatch your add address action
    const address = {
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      street: data.street,
      apartment: data.apartment,
      city: data.city,
      zipCode: data.zipCode,
      country: data.country,
      defaultDeliveryAddress: data.isDefaultDelivery,
      defaultBillingAddress: data.isDefaultBilling,
    };
  
    const finalObject = {
      address,
    };
    console.log('Final Object:', finalObject);
    // setShowForm(false); 
    if ( address.firstName != '' && address.lastName != '' && address.phone != '' && address.street != '' && address.city != '' && address.zipCode != '' && address.country != '') {
      console.log('CALLED12')
      handleTimeoutAlert(finalObject)

    }

  };

  return (
    <>
    {console.log('formData', dataAvaliable)}
      <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: '20px' }}>
        <Row>
          <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
            <Label className='form-label' for='firstName'>First Name *</Label>
            <Controller
              id='firstName'
              name='firstName'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text' 
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  field.onChange(e.target.value);
                }}
                 invalid={errors.firstName && true} placeholder='Enter First Name' />
              )}
            />
            {errors.firstName && <FormFeedback>{errors.firstName.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
            <Label className='form-label' for='lastName'>Last Name *</Label>
            <Controller
              id='lastName'
              name='lastName'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  field.onChange(e.target.value);
                }}
                 invalid={errors.lastName && true} placeholder='Enter Last Name' />
              )}
            />
            {errors.lastName && <FormFeedback>{errors.lastName.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
            <Label className='form-label' for='phone'>Phone No. *</Label>
            <Controller
              id='phone'
              name='phone'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  field.onChange(e.target.value);
                }}
                 invalid={errors.phone && true} placeholder='Enter Phone Number' />
              )}
            />
            {errors.phone && <FormFeedback>{errors.phone.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='12' md='12' sm="12" xl="12">
            <Label className='form-label' for='street'>Street *</Label>
            <Controller
              id='street'
              name='street'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={street}
                onChange={(e) => {
                  setStreet(e.target.value);
                  field.onChange(e.target.value);
                }}
                invalid={errors.street && true} placeholder='Enter Street Address or P.O Box' />
              )}
            />
            {errors.street && <FormFeedback>{errors.street.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='12' md='12' sm="12" xl="12">
            <Label className='form-label' for='apartment'>Apartment</Label>
            <Controller
              id='apartment'
              name='apartment'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={apartment}
                onChange={(e) => {
                  setApartment(e.target.value);
                  field.onChange(e.target.value);
                }}
                 placeholder='Enter Apartment, Floor, Unit etc.' />
              )}
            />
          </Col>

          <Col className='mb-1' lg='6' md='6' sm="12" xl="6">
            <Label className='form-label' for='city'>City *</Label>
            <Controller
              id='city'
              name='city'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                  field.onChange(e.target.value);
                }}
                invalid={errors.city && true} placeholder='Enter City' />
              )}
            />
            {errors.city && <FormFeedback>{errors.city.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='6' md='6' sm="12" xl="6">
            <Label className='form-label' for='province'>Province/State *</Label>
            <Controller
              id='province'
              name='province'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={province}
                onChange={(e) => {
                  setProvince(e.target.value);
                  field.onChange(e.target.value);
                }} invalid={errors.province && true} placeholder='Enter Province/State' />
              )}
            />
            {errors.province && <FormFeedback>{errors.province.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='6' md='6' sm="12" xl="6">
            <Label className='form-label' for='country'>Country *</Label>
            <Controller
              id='country'
              name='country'
              control={control}
              render={({ field }) => (
                <Input {...field} type='text'
                value={country}
                onChange={(e) => {
                  setCountry(e.target.value);
                  field.onChange(e.target.value);
                }}
                 invalid={errors.country && true} placeholder='Enter Country' />
              )}
            />
            {errors.country && <FormFeedback>{errors.country.message}</FormFeedback>}
          </Col>

          <Col className='mb-1' lg='6' md='6' sm="12" xl="6">
            <Label className='form-label' for='zipCode'>Zip Code *</Label>
            <Controller
              id='zipCode'
              name='zipCode'
              control={control}
              render={({ field }) => (
                <Input {...field} type='number'
                value={zipCode}
                onChange={(e) => {
                  setZipCode(e.target.value);
                  field.onChange(e.target.value);
                }}
                 invalid={errors.zipCode && true} placeholder='Enter Zip Code' />
              )}
            />
            {errors.zipCode && <FormFeedback>{errors.zipCode.message}</FormFeedback>}
          </Col>
          <Col className='mb-1' lg='12' md='12' sm="12" xl="12">
          <Controller
            name="isDefaultDelivery"
            control={control}
            render={({ field }) => (
              <div>
                <Input
                  type="checkbox"
                  checked={isDefaultDelivery}
                  onChange={(e) => {
                    setIsDefaultDelivery(e.target.checked);
                    field.onChange(e.target.checked);
                  }}
                /> &nbsp;
                <Label className='form-label'>Set this as default delivery address</Label>
              </div>
            )}
          />
        </Col>

        <Col className='mb-1' lg='12' md='12' sm="12" xl="12">
          <Controller
            name="isDefaultBilling"
            control={control}
            render={({ field }) => (
              <div>
                <Input
                  type="checkbox"
                  checked={isDefaultBilling}
                  onChange={(e) => {
                    setIsDefaultBilling(e.target.checked);
                    field.onChange(e.target.checked);
                  }}
                /> &nbsp;
                <Label className='form-label'>Set this as default billing address</Label>
              </div>
            )}
          />
        </Col>

        </Row>
        <div className='py-4 d-flex justify-content-end gap-2'>
          <button type='submit' className='btn' style={{ backgroundColor: '#FBBD34', color: 'white' }}>{dataAvaliable ? 'Save Changes' : 'Save Address'}</button>
          {/* <button type='button' className='btn' style={{ backgroundColor: '#D9534F', color: 'white' }} onClick={onCancel}>Cancel</button> */}
        </div>
      </form>
    </>
  );
};

export default AddressBookForm;
